export default function PartnerFooter() {
  return (
    <footer className="bg-ink-900 rounded-t-3xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-24">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-8 sm:gap-10 lg:gap-16 mb-10 sm:mb-16">
          {/* CTA column */}
          <div className="lg:col-span-4">
            <h3 className="text-2xl sm:text-3xl lg:text-5xl font-light text-white leading-tight mb-4 sm:mb-6 lg:mb-8">
              Klaar voor een nieuwe vloer?
            </h3>
            <p className="text-white/70 text-sm sm:text-base mb-4 sm:mb-6 lg:mb-8 leading-relaxed">
              Bezoek onze showroom of vraag een vrijblijvende offerte aan voor jouw nieuwe vloer. We helpen je graag verder.
            </p>
            <a
              href="#offerte"
              className="inline-flex items-center gap-2 bg-brass-500 hover:bg-brass-600 text-white px-5 sm:px-6 py-2.5 sm:py-3 rounded-full text-sm font-medium transition-all hover:shadow-lg whitespace-nowrap"
            >
              Plan afspraak
              <i className="ri-arrow-right-line text-base"></i>
            </a>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-semibold text-white mb-3 sm:mb-4 text-sm">Diensten</h4>
            <ul className="space-y-2 sm:space-y-3">
              {['PVC Click Vloeren', 'PVC Lijm Vloeren', 'Laminaat Vloeren', 'Gietvloeren', 'Vloerverwarming'].map((item) => (
                <li key={item}>
                  <a href="#services" className="text-xs sm:text-sm text-white/70 hover:text-brass-400 transition-colors block py-1">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-3 sm:mb-4 text-sm">Per Ruimte</h4>
            <ul className="space-y-2 sm:space-y-3">
              {['Woonkamer', 'Keuken', 'Slaapkamer', 'Hal / Gang', 'Kantoor'].map((item) => (
                <li key={item}>
                  <a href="#services" className="text-xs sm:text-sm text-white/70 hover:text-brass-400 transition-colors block py-1">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-3 sm:mb-4 text-sm">Locaties</h4>
            <ul className="space-y-2 sm:space-y-3">
              {['Amsterdam', 'Amstelveen', 'Haarlem', 'Zaandam', 'Diemen', 'Aalsmeer'].map((item) => (
                <li key={item}>
                  <a href="#" className="text-xs sm:text-sm text-white/70 hover:text-brass-400 transition-colors block py-1">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-3 sm:mb-4 text-sm">Informatie</h4>
            <ul className="space-y-2 sm:space-y-3">
              {[
                { label: 'Offerte Aanvragen', href: '#offerte' },
                { label: 'Proces', href: '#proces' },
                { label: 'FAQ', href: '#faq' },
                { label: 'Contact', href: 'tel:+31209876543' },
              ].map((item) => (
                <li key={item.label}>
                  <a href={item.href} className="text-xs sm:text-sm text-white/70 hover:text-brass-400 transition-colors block py-1">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Large decorative text */}
        <div className="relative mb-8 sm:mb-12 overflow-hidden">
          <div className="text-center text-4xl sm:text-6xl md:text-7xl lg:text-[100px] xl:text-[140px] font-bold text-white/[0.04] leading-none select-none whitespace-nowrap">
            PVC VLOER
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/20 pt-6 sm:pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs sm:text-sm text-white/60 text-center sm:text-left">
            © 2026 PVC Vloer Nederland. Alle rechten voorbehouden.
          </p>
          <div className="flex items-center gap-4 sm:gap-6">
            <a href="#" className="text-xs sm:text-sm text-white/60 hover:text-white/90 transition-colors">
              Privacyverklaring
            </a>
            <a href="#" className="text-xs sm:text-sm text-white/60 hover:text-white/90 transition-colors">
              Algemene Voorwaarden
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}